import { Bandeau } from './Bandeau';
import { Bouton } from './Bouton';

/**
 * **L'erreur, AVEC son réessai** — le deuxième des trois états obligatoires.
 *
 * **Le message affiché vient du serveur quand il en donne un**, et c'est voulu :
 * `DOCTRINE.md` §5 pose une enveloppe unique dont le `message` « est destiné à l'humain ».
 * Ce que le front ne fait **jamais**, c'est brancher un comportement dessus : « **`code`
 * est le contrat réel** », et les écrans qui décident branchent sur lui.
 */
type Props = {
  readonly message: string;
  readonly onReessayer?: () => void;
};

export function EtatErreur({ message, onReessayer }: Props) {
  return (
    <Bandeau
      ton="echec"
      action={
        onReessayer && (
          <Bouton variante="douce" taille="petite" onClick={onReessayer}>
            Réessayer
          </Bouton>
        )
      }
    >
      {message}
    </Bandeau>
  );
}
